import { render, staticRenderFns } from "./404.vue?vue&type=template&id=4f2e382f"
var script = {}
import style0 from "./404.vue?vue&type=style&index=0&id=4f2e382f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports